/* eslint-disable eqeqeq */
import { Button, Mask, Result, Image } from "antd-mobile-v5";
import { useEffect, useState } from "react";
import { useEffectOnce } from "react-use";
import styled from "styled-components";
import { isMobile } from ".";

const RegisterWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  height: 100vh;
  background: #f8f8f7;
  .navBar {
    background: #fff;
  }
  .download-box {
    padding: 0 24px;
  }
  .download {
    margin-top: 40px;
  }
  .adm-result {
    background: #f8f8f7;
  }
  .adm-result-description {
    margin: 0;
  }
  .adm-form .adm-form-footer {
    padding: 20px 24px;
  }
`;
export default function Success() {
  const [visible, setVisible] = useState(false);
  let u = navigator.userAgent,
    ua = u.toLowerCase();

  const [isAndroid, setIsAndroid] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isIOS9, setIsIOS9] = useState(false);
  const [isWeixin, setIsWeixin] = useState(false);

  //检查系统和版本
  function checkSystem() {
    if (ua.indexOf("micromessenger") > -1) {
      setIsWeixin(true);
      return;
    } else if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
      //android终端或者uc浏览器
      //Android系统
      setIsAndroid(true);
    }
    if (ua.indexOf("like mac os x") > 0) {
      //ios
      var regStr_saf = /os [\d._]*/gi;
      var verinfo = ua.match(regStr_saf);
      let version = Number(
        (verinfo + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".")
      );
      var version_str = version + "";
      if (version_str != "undefined" && version_str.length > 0) {
        if (version >= 8) {
          // ios9以上

          setIsIOS9(true);
        } else {
          setIsIOS(true);
        }
      }
    }
  }

  function goAndriAddr() {
    //跳转到安卓商城地址
    let isVivo = ua.indexOf("vivo") != -1;
    let isHuawei = ua.indexOf("huawei") != -1 || ua.indexOf("honor") != -1;
    let isMi = ua.indexOf("redmi") != -1 || ua.indexOf("xiaomi") != -1;
    let isMeizu = ua.indexOf("meizu") != -1;
    let isSamsung = ua.indexOf("sm") != -1;
    let isOppo = ua.indexOf("pacm00") != -1 || ua.indexOf("oppo") != -1;
    let hreff = "";
    if (isVivo) {
      hreff = "vivoMarket://details?id=com.softlake";
    }
    // else if (isHuawei)
    // {
    //   hreff = "appmarket://details?id=com.softlake";
    // }
    else if (isMi) {
      hreff = "mimarket://details?id=com.softlake";
    } else if (isMeizu) {
      hreff = "mstore://details?id=com.softlake";
    } else if (isSamsung) {
      hreff = "samsungapps://ProductDetail/com.softlake";
    } else if (isSamsung) {
      hreff = "samsungapps://ProductDetail/com.softlake";
    } else if (isOppo) {
      hreff = "oppomarket://details?packagename=com.softlake";
    } else {
      hreff = "tmast://appdetails?pname=com.softlake"; // 官网下载地址  也可以跳到应用宝
    }
    console.log(hreff);
    window.location.href = hreff;
  }
  function goIOSAddr() {
    window.location.href = "https://apps.apple.com/cn/app/id6468010810";
  }

  const toDownLoad = () => {
    if (isIOS || isIOS9) {
      goIOSAddr();
    } else if (isAndroid) {
      goAndriAddr();
    } else if (isWeixin) {
      setVisible(true);
    }
  };
  useEffectOnce(() => {
    checkSystem();
  });
  useEffect(() => {
    document.title = "注册成功";
  }, []);
  return (
    <RegisterWrapper>
      <>
        {/* <NavBar className="navBar" onBack={() => history.go(-1)}>
          注册成功
        </NavBar> */}
        <main>
          <Result
            status="success"
            title={<h3 style={{ margin: 0 }}>注册成功</h3>}
            // description={
            //   <Button color="primary" fill="none" style={{ fontSize: 14 }}>
            //     请前往App Store下载「天衣云」
            //   </Button>
            // }
          />
          {isMobile() && (
            <div className="download-box">
              <Button
                block
                color="primary"
                className="download"
                size="large"
                onClick={toDownLoad}
              >
                前往下载
              </Button>
            </div>
          )}
        </main>
      </>
      <Mask visible={visible} onMaskClick={() => setVisible(false)} />
      <Image
        src={"/tip.png"}
        style={{
          position: "absolute",
          width: "70%",
          zIndex: 9999,
          right: 20,
          top: 0,
          display: visible ? "block" : "none",
        }}
      />
    </RegisterWrapper>
  );
}
